import { createFileRoute, redirect } from '@tanstack/react-router'
import { FORCE_UPDATE_SESSION_KEY } from '@/features/native-app/model'
import { ForceUpdateScreen } from '@/features/native-app/ui/ForceUpdateScreen'

export const Route = createFileRoute('/app-update')({
  beforeLoad: () => {
    // In DEV, the route is always accessible (no gate) so design/QA can navigate
    // directly; ?preview=true is still supported for forward-compatibility.
    if (import.meta.env.DEV) {
      return
    }

    const raw = sessionStorage.getItem(FORCE_UPDATE_SESSION_KEY)
    if (!raw) {
      throw redirect({ to: '/', replace: true })
    }
  },
  loader: () => {
    const raw = sessionStorage.getItem(FORCE_UPDATE_SESSION_KEY)
    sessionStorage.removeItem(FORCE_UPDATE_SESSION_KEY)

    if (!raw) {
      return {}
    }

    try {
      return JSON.parse(raw) as {
        updateUrl?: string
        installedVersion?: string
        minimumVersion?: string
      }
    } catch {
      return {}
    }
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { updateUrl, installedVersion, minimumVersion } = Route.useLoaderData()

  return (
    <ForceUpdateScreen
      updateUrl={updateUrl}
      installedVersion={installedVersion}
      minimumVersion={minimumVersion}
    />
  )
}
